var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"gnb"},[_c('ul',{staticClass:"list_gnb"},[_c('li',{staticClass:"on"},[_c('span',{staticClass:"link_gnb"},[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }